module.exports = {"653201001":"奴尔巴格街道","653201002":"古江巴格街道","653201003":"古勒巴格街道","653201004":"纳尔巴格街道","653201100":"拉斯奎镇","653201101":"玉龙喀什镇","653201200":"肖尔巴格乡","653201201":"伊里其乡","653201202":"古江巴格乡","653201203":"吐沙拉乡","653201204":"吉亚乡","653201205":"阿克恰勒乡","653201401":"北京工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653201.json
// module id = 2900
// module chunks = 0